import React, {useState} from "react";
import Popup from "../Components/Popup";

import floccc from "../assets/floccc.svg"
import line from "../assets/line.svg"
import outtextLogo from "../assets/outtextLogo.svg"
import strong from "../assets/strongLogo.svg"
import twoPhones from "../assets/iphone13.png"
import dotsFirst from "../assets/dots1.svg"
import dotsSecond from "../assets/dots2.svg"
import statisticBreak from "../assets/statistics.svg"
import girl from "../assets/afrogirl.png"
import wishIphone from "../assets/iPhone13_wish.png"
import demandIphone from "../assets/iPhone13_demand.png"
import wishIcon from "../assets/wishList.svg"
import aquisition from "../assets/aquisition.svg"
import owner from "../assets/ownership.svg"
import releases from "../assets/releases.svg"
import bank from "../assets/bank.svg"
import inst from "../assets/instagram.svg"
import facebook from "../assets/facebook.svg"
import done from "../assets/done.svg"
import checkprice from "../assets/checkprice.svg"
import rate from "../assets/rate.svg"
import smile from "../assets/smile.svg"
import firstPhoto from "../assets/photo-left-first.png"
import second from "../assets/photo-left-second.png"
import third from "../assets/photo-left-third.png"
import fourth from "../assets/photo-left-fourth.png"
import fifth from "../assets/photo-left-fifth.png"
import last from "../assets/photo-left-last.png"
import leftFirst from "../assets/photo-right-first.png"
import leftSecond from "../assets/photo-right-second.png"
import leftThird from "../assets/photo-right-third.png"
import leftFourth from "../assets/photo-right-fourth.png"
import leftFifth from "../assets/photo-right-fifth.png"
import android from "../assets/google_market.svg"
import apple from "../assets/apple.svg"
import diagram from "../assets/diagram.svg"
import "../styles/main_global.css";
import "./styles/landing.css";
import useResize from "../Constants/useResize";

// import {setToken} from "../main-store/auth/actions";

function Landing() {
    const [open, setOpen] = useState(false)
    const [navOpen, setNavOpen] = useState(false)
    const {innerWidth} = useResize()

    const burgerToggle = () => {
        setNavOpen(!navOpen);
    }
    return (
        <div className={`flock-landing-page ${navOpen ? "flock-landing-page1" : ""} `}>
            <header className={`hero-header ${navOpen ? "hero-header1" : ""}`}>
                <div className="left-side-header">
                    <a href={"#header"}><img className="logo-flocc" src={floccc} alt="Logo"/></a>
                    <a href={"#how-it-works"} id={"how-it-works-header"}>How it Works</a>
                    <a href={"#breaking"} id={"about-header"}>About</a>
                </div>
                {innerWidth >= 900 ?
                    <button onClick={(() => {
                        setOpen(true)
                    })} className="join-button">Join the Flocc</button>
                    :
                    <div onClick={(() => {
                        burgerToggle()
                    })} className={`burger-menu ${navOpen ? "active" : ""}`}>
                        <div/>
                        <div/>
                        <div/>
                    </div>

                }
            </header>
            <div className={`nav-sidebar ${navOpen ? "active" : ""}`}>
                <a onClick={(() => {
                    setNavOpen(false)
                })} href="https://flocc.netlify.app/#how-it-works">How it Works</a>
                <a onClick={(() => {
                    setNavOpen(false)
                })} href="https://flocc.netlify.app/#breaking">About</a>
                <button onClick={(() => {
                    setOpen(true)
                })} className="join-button">Join the Flocc
                </button>
            </div>
            <div id="header"  className="main-page">
                <div className="hero-main">
                    <div className="block"/>
                    <div className="left-side-green">
                        <img className={'dots'} src={dotsFirst} alt={'dots'}/>
                        <span className="little-green-text">All for one. One for all.</span>
                        <div className="title-section">
                            <h1 className="title-hero">Let your <br/> investments <br/> take flight</h1>
                            <img className="orange-line" src={line} alt="Line"/>
                        </div>
                        <p className="sub-text">Whether you're a beginner or an experienced investor, join our growing
                            community of people owning a share of iconic assets with the potential to deliver
                            significant
                            returns.</p>
                        <div className="join-buttons-app">
                            <div className="button">
                                <img src={apple} alt=""/>
                                <span>Download for iOS</span>
                            </div>
                            <div className="button">
                                <img src={android} alt="Android"/>
                                <span>Download for Android</span>
                            </div>
                        </div>
                    </div>
                    <img className="hero-image" src={twoPhones} alt="Phone Side"/>
                </div>
                <div id="breaking" className="breaking-section">
                    <div className="left-side-second-section">
                        <div className="title-section">
                            <img className={'dots2'} src={dotsSecond} alt={'dots'}/>
                            <img className="block-image" src={statisticBreak} alt="Statistics"/>
                            <h2 className="second-title">Breaking <br/> boundaries</h2>
                            <img className="orange-line" src={line} alt="Line"/>
                        </div>
                        <p className="breaking-text">
                            The world’s wealthiest people have invested in things such as fine wine, art and watches for
                            hundreds of years. The same opportunities are usually out of reach for everyone else. We're
                            here
                            to change that. We help you to own a share of whatever it is you’re passionate about.
                            Offering a
                            personal touch that makes assets more assessable.
                        </p>
                        <button className="join-button" onClick={(() => {
                            setOpen(true)
                        })}>Join the Flocc
                        </button>
                    </div>
                    <div className="right-side-second-section">
                        <img className="girl-order" src={girl} alt="Breaking Girl"/>
                        <div className="order-block">
                            <span className="category">Buy Rolex Daytona 6265</span>
                            <span className="price">£2,500</span>
                            <div className="value">
                                <img src={checkprice} alt="Price"/>
                                <span>Valued at £50,000</span>
                            </div>
                            <button className="order-button">Review order</button>
                        </div>
                        <div className="notification-section">
                            <img src={smile} alt="Notification"/>
                            <div className="left-side">
                                <div className="block-count">
                                    <span className="percentage">+124%</span>
                                    <img className="rate" src={rate} alt="Rate"/>
                                </div>
                                <p>since 2018 for similar items</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="stronger-section">
                    <img className={'dots3'} src={dotsFirst} alt={'dots'}/>
                    <div className="left-photo-block">
                        <div className="first-block">
                            <img src={firstPhoto} alt=""/>
                            <img src={second} alt=""/>
                            <img src={third} alt=""/>
                        </div>
                        <div className="first-block">
                            <img src={fourth} alt=""/>
                            <img src={fifth} alt=""/>
                        </div>
                        <div className="first-block">
                            <img src={last} alt=""/>
                        </div>
                    </div>
                    <div className="center-strong">
                        <div className="title-section-strong">
                            <img src={strong} alt="Strong Icon"/>
                            <h2 className="strong-title">We’re stronger <br/> together</h2>
                            <img className="orange-line" src={line} alt="Line"/>
                        </div>
                        <p className="strong-subscribe">At Flocc, we believe in the power of people and the value of
                            community. We use our expertise and
                            personal service to enable you to invest however, whenever and wherever you like.
                        </p>
                        <button className="join-button" onClick={(() => {
                            setOpen(true)
                        })}>Join the Flocc
                        </button>
                    </div>
                    <div className="right-photo-block">
                        <div className="first-block">
                            <img src={leftSecond} alt=""/>
                            <img src={leftFourth} alt=""/>
                        </div>
                        <div className="first-block second">
                            <img src={leftFirst} alt=""/>
                            <img src={leftThird} alt=""/>
                            <img className="last-photo" src={leftFifth} alt=""/>
                        </div>
                    </div>
                </div>
                <div className="wish-section top">
                    <div className="block"/>
                    <img className={'dots4'} src={dotsFirst} alt={'dots'}/>
                    <div className="notification order-image">
                        <img className="wish-section-phone" src={wishIphone} alt="Iphone"/>
                        <div className="notification-section">
                            <span>Rolex Submariner added</span>
                            <img src={done} alt="Notification"/>
                        </div>
                    </div>
                    <div className="bring-block order-one">
                        <div className="title-section">
                            <img src={wishIcon} alt="Wish Icon"/>
                            <h2 className="wish-section-title">Bringing <br/> collectables <br/> within reach</h2>
                            <img className="orange-line" src={line} alt="Line"/>
                        </div>
                        <p className="wish-text">Whether you're looking to expand your portfolio or build a collection
                            of
                            fine wine and spirits,
                            classic cars or rare collectables, Flocc allows you to do it at the touch of a button and
                            then
                            follow their performance.</p>
                        <button className="join-button" onClick={(() => {
                            setOpen(true)
                        })}>Join the Flocc
                        </button>
                    </div>
                </div>
                <div className="wish-section">
                    <div className="block"/>
                    <div className="bring-block supplying-section">
                        <div className="title-section">
                            <img src={diagram} alt="Wish Icon"/>
                            <h2 className="wish-section-title">Supplying the <br/> demand</h2>
                            <img className="orange-line" src={line} alt="Line"/>
                        </div>
                        <p className="wish-text">Our principals are based on the first rule of economics; supply and
                            demand.
                            We look to purchase physical assets that may increase in value because of their rarity,
                            growing
                            demand or falling supply.</p>
                        <button className="join-button" onClick={(() => {
                            setOpen(true)
                        })}>Join the Flocc
                        </button>
                    </div>
                    <div className="notification">
                        <img className={'dots5'} src={dotsFirst} alt={'dots'}/>
                        <img className="wish-section-phone demand" src={demandIphone} alt="Iphone"/>
                    </div>
                </div>
                <div id="how-it-works" className="how-it-works-section">
                    <div className="text-section-title">
                        <h2 className="how-it-work-title">How it works</h2>
                        <img className="orange-line" src={line} alt="Line"/>
                    </div>
                    <div className="work-category">
                        <div className="category">
                            <img src={aquisition} alt="Aquisition"/>
                            <span className="count">1.<span className="category-type">Aquisition</span></span>
                            <p className="work-text">We find and verify one-off and rare assets for you.</p>
                        </div>
                        <div className="category">
                            <img src={owner} alt="Aquisition"/>
                            <span className="count">2.<span
                                className="category-type">Division of ownership</span></span>
                            <p className="work-text">Each asset is split it into smaller fractions and we handle the
                                safekeeping, insurance and maintenance required.</p>
                        </div>
                        <div className="category">
                            <img src={releases} alt="Aquisition"/>
                            <span className="count">3.<span className="category-type">Releases</span></span>
                            <p className="work-text">The fractions are listed on our platform, offering you the chance
                                to buy a piece of each listed asset.</p>
                        </div>
                        <div className="category">
                            <img src={bank} alt="Aquisition"/>
                            <span className="count">4.<span className="category-type">Cashing in</span></span>
                            <p className="work-text">Sell your fractions on our marketplace, or get your returns if
                                Flocc sells the whole asset.</p>
                        </div>
                    </div>
                </div>
                <div className="footer-section">
                    <div className="join-background">
                        <div className="text-section">
                            <img className={'dots6'} src={dotsFirst} alt={'dots'}/>
                            <img src={outtextLogo} alt=""/>
                            <div className='title-section-join'>
                                <h1>Join the Flocc</h1>
                                <img className="orange-line" src={line} alt="Line"/>
                            </div>
                            <p>Get ready to start building your alternative asset collection. Sign up for access to our
                                latest releases on the Flocc app.</p>
                            <button className="join-button" onClick={(() => {
                                setOpen(true)
                            })}>sign me up
                            </button>
                        </div>
                    </div>
                    <div className="join-last-footer">
                        <h3>Let’s Flocc Together</h3>
                        <div className="social-network">
                            <a href="https://flocc.netlify.app/">
                            <div className="round">
                                <img src={inst} alt="Instagram"/>
                            </div>
                            </a>
                            <a href="https://flocc.netlify.app/">
                            <div className="round">
                                <img src={facebook} alt="Facebook"/>
                            </div>
                            </a>
                        </div>
                        <div className="privacy-block">
                            <a href="https://flocc.netlify.app/">2021 Flocc </a>
                            <a href="https://flocc.netlify.app/">&nbsp; • &nbsp; Privacy</a>
                            <a href="https://flocc.netlify.app/">&nbsp; • &nbsp; Terms</a>
                        </div>
                    </div>

                </div>
                {open ?
                    <Popup
                        setOpen={e => setOpen(e)}

                    />
                    : null
                }
            </div>

        </div>
    )
}

// const mapStateToProps = (state) => {
//     return {
//         token: state.auth.token,
//     };
// };
//
// const mapDispatchToProps = () => {
//     return {
//         setToken,
//     };
// };

export default (Landing);
